module.exports = __webpack_public_path__ + "ico/windows_large.png";